import { gql } from '@apollo/client';

export const STATE_TRANSITION_QUERY = gql`
  query stateTransition($id: Int!) {
    stateTransition(id: $id) {
      id
      documentTypeId
      fromStateId
      fromStateName
      fromStateIsActive
      toStateId
      toStateName
      toStateIsActive
      saveImage
      requiresConfirmation
      notifyResponsible
      notifyUser
      isInitial
      isFinal
      textResourceId
      userGroupsNotification {
        documentAllowedTransitionId
        userGroupId
      }
    }
  }
`;
